import { BaseModel } from "../Generics/BaseModel"
import { GenericFoodEntity } from "../MealsAndDrinks/GenericFoodEntity"
import { ComboItemReference } from "./ComboItemReference"

export class ComboEntity extends BaseModel {
  id: number
  
  mealId: number

  genericFoodEntity: GenericFoodEntity

  items: ComboItemReference[]

  constructor(data: Partial<ComboEntity> = {}) {
    super()

    const sourceData = data as any

    const mealEntityGenericFood = sourceData.mealEntity?.genericFoodEntity

    const mealEntityCategoryName = (mealEntityGenericFood?.category?.name ?? "").trim().toLowerCase()

    const isComboMealEntity = mealEntityCategoryName === "combos"

    this.id = sourceData.id ?? -1

    this.mealId = sourceData.mealId ?? sourceData.mealEntity?.id ?? -1

    this.genericFoodEntity = new GenericFoodEntity(sourceData.genericFoodEntity ?? (isComboMealEntity
      ? mealEntityGenericFood
      : undefined))

    this.items = (sourceData.items ?? sourceData.comboItems ?? []).map((e: ComboItemReference) => new ComboItemReference(e))
  }
}
